/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Jan 30 2024
 **/

import styled from "@emotion/styled";

export const Input = styled.input`
	&[type="range"] {
		-webkit-appearance: none;
		appearance: none;
		background: transparent;
		cursor: pointer;
	}

	/***** Chrome, Safari, Opera, and Edge Chromium *****/
	&[type="range"]::-webkit-slider-runnable-track {
		background-color: ${({ theme }) => theme.colors.neutral_50_40};
		height: 10px;
		border-radius: 5px;
	}

	/******** Firefox ********/
	&[type="range"]::-moz-range-track {
		background-color: ${({ theme }) => theme.colors.neutral_50_40};
		height: 10px;
		border-radius: 5px;
	}

	&[type="range"]::-webkit-slider-thumb {
		-webkit-appearance: none; /* Override default look */
		appearance: none;
		margin-top: -5px;
		background-color: #edeef1;
		height: 20px;
		width: 20px;
		border-radius: 20px;
	}
`;
